module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dMdDO"))).then(() => parcelRequire('1iHdE'));